import { ClubModel, ContextModel, ContextCourtModel } from '@bayclubs/court-booking-employee-api';

export enum CoreActionTypes {
    LoadContext = '[CB Core] Load context',
    LoadContextSuccess = '[CB Core] Load context success',
    SetUpClubContext = '[CB Core] Set up club context',
    SelectedClubChanged = '[CB Core] Selected club changed',
    SelectedClubChangedSuccess = '[CB Core] Selected club changed success',
    LoadClubCourts = '[CB Core] Load club courts',
    LoadClubCourtsSuccess = '[CB Core] Load club courts success'
}

export class LoadContextAction {
    static readonly type = CoreActionTypes.LoadContext;
}

export class LoadContextSuccessAction {
    static readonly type = CoreActionTypes.LoadContextSuccess;
    constructor(public context: ContextModel) {}
}

export class SetUpClubContext {
    static readonly type = CoreActionTypes.SetUpClubContext;

    constructor(public clubId: string = null) {}
}

export class SelectedClubChanged {
    static readonly type = CoreActionTypes.SelectedClubChanged;
    constructor(public clubId: string = null) {}
}

export class SelectedClubChangedSuccess {
    static readonly type = CoreActionTypes.SelectedClubChangedSuccess;

    constructor(public club: ClubModel) {}
}

export class LoadClubCourtsAction {
    static readonly type = CoreActionTypes.LoadClubCourts;
    constructor(public club: ClubModel) {}
}

export class LoadClubCourtsSuccessAction {
    static readonly type = CoreActionTypes.LoadClubCourtsSuccess;
    constructor(public courts: ContextCourtModel[]) {}
}
